import React from 'react';

// It's worth noting that if passed in handler is a new function on every render
//   that will cause this effect callback/cleanup to run every render.
//   It's not a big deal but to optimize you can wrap handler in useCallback
//   before passing it into this hook.
function useOnWindowResize(handler) {
  React.useEffect(() => {
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, [handler]);
}

export default useOnWindowResize;
